// @ts-ignore
import draftToHtml from 'draftjs-to-html';
// @ts-ignore
import htmlToDraft from 'html-to-draftjs';

import React, {useEffect,useState} from "react";
import { Col, Row, Card, CardBody, Container, Button, Modal, ModalHeader,FormGroup, Label, Form, Alert} from "reactstrap";
import Breadcrumbs from "../../../Components/Common/Breadcrumb";
import { Editor } from "react-draft-wysiwyg";
import axios from "axios";
import { EditorState,ContentState, convertToRaw } from 'draft-js';
import Dropzone from "react-dropzone"
import { Link } from "react-router-dom";
// import { useParams } from 'react-router-dom';

import ImageHolder from "../../../assets/images/imgplaceholder.png"
import { CustomReactComponents } from '../others/Custom React Components/CustomReactComponents';
const NavContentManagement = () => {
  
const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
    if (reason === "clickaway") { return; }
    setAlertMsgg({ ...alertMsgg, open: false })
};
const [showloader, setshowloader] = useState(true);



const [contents, setcontents] = useState<any>([]);
const [subpath, setsubpath] = useState<any>("");
const [contenttypes, setcontenttypes] = useState<any>([]);
const [texttypes, settexttypes] = useState<any>([]);
const [editorState, setEditorState] = useState(EditorState.createEmpty());
const [categories, setcategories] = useState<any>([]);
// const { sdid } = useParams<{ sdid: string }>();
// const currentSdid = sdid || '1';
let sdid = String(window.location.href).split("/")[String(window.location.href).split("/").length-1]
const fetch_experts = async () => {
    try {
      setshowloader(true);
      const response = await axios.post(`accounts/handleadmdomains`, { render: true, sdid: sdid }, { withCredentials: true, headers: { 'Content-Type': 'application/json'} });
      console.log('response____1 ', response)
      if (response.status === "SENT") {
          setshowloader(false);
          setcontents(response.domains.navcontents)
          setsubpath(`${response.domains.domain.name} > ${response.domains.name}`)
          setcontenttypes(response.content_types)
          settexttypes(response.text_types)
          setcategories(response.cats)
        }
      } catch (error:any) {
          if (error.response) {
              if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); } 
              else if (error.response.status === 403) {
                  setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                  setTimeout(()=>{window.location.href="/logout"}, 2000)
              } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
          } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
          setshowloader(false);
      }            
    }
React.useEffect(() => {
  fetch_experts();
}, []); // Empty dependency array means this runs only once on mount
  const [selectedcontent, setselectedcontent] = useState<any>(null); 
  const appendToEditor = (newHtml: string) => {
    const currentContent = editorState.getCurrentContent();
    const currentRaw = convertToRaw(currentContent);
    const newBlock = htmlToDraft(newHtml);

    const combinedContentState = ContentState.createFromBlockArray([
      ...currentRaw.blocks,
      ...newBlock.contentBlocks,
    ]);

    const newEditorState = EditorState.createWithContent(combinedContentState);
    setEditorState(newEditorState);

    const updatedHtml = draftToHtml(convertToRaw(combinedContentState));
    setselectedcontent({ ...(selectedcontent || {}), text: updatedHtml });
  };

useEffect(() => {
  if (selectedcontent && selectedcontent.text) {
    const blocksFromHtml = htmlToDraft(selectedcontent.text);
    if (blocksFromHtml) {
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      setEditorState(EditorState.createWithContent(contentState));
    }
  } else {
    setEditorState(EditorState.createEmpty());
  }
}, [selectedcontent?.id]);



const [selectedImage, setselectedImage] = useState<any>([])
const [selectedVideo, setselectedVideo] = useState<any>([])
function handleAcceptedImage(files: any) {
  const imageFiles = files.filter((file: any) => file.type.startsWith('image/'));
  if (imageFiles.length !== files.length) {
    alert('Please upload image files only');
    return;
  }
  
  imageFiles.map((file: any) =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    })
  );
  setselectedImage(imageFiles);
}
function handleAcceptedVideo(files: any) {
  const videoFiles = files.filter((file: any) => file.type.startsWith('video/'));
  if (videoFiles.length !== files.length) {
    alert('Please upload video files only');
    return;
  }

  videoFiles.map((file: any) =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    })
  );
  setselectedVideo(videoFiles);
}
function formatBytes(bytes:any, decimals = 2) {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}





const [managecontent, setmanagecontent] = useState(false);
const [managedelete, setmanagedelete] = useState(false);

const add_edit_content = async (cid:any=null, push:any=false, todelete:any=false) => {
  console.log("selectedcontent____________", selectedcontent)
  if (push){
    try{
      setshowloader(true);
      const formData = new FormData();
      formData.append('sdid', sdid);
      formData.append('selectedcontent', JSON.stringify(selectedcontent));
      formData.append('action', todelete ? "delete" : (selectedcontent?.id ? "edit" : "add"));
      if (selectedcontent.itype === 'image' && selectedImage.length > 0) { formData.append('image', selectedImage[0]); }
      if (selectedcontent.itype === 'video' && selectedVideo.length > 0) { formData.append('video', selectedVideo[0]); }

      const response = await axios.post(`accounts/handleadmcontents`, formData, { withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' } });

      console.log('response____ ', response)
      if (response.status === "DONE") {
        setshowloader(false);
        setAlertMsgg({ ...alertMsgg, open: true, content: "Content updated!", type: "success" });
        setTimeout(() => {
          setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
        }, 4000);
        
        // window.location.reload()
        fetch_experts();
      }
      setselectedcontent(null)
      setmanagedelete(false); setmanagecontent(false);
      return null
    } catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); 
            setTimeout(() => {
                setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 2000);} 
            else if (error.response.status === 403) {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
        } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
        setshowloader(false);
    }       
  }
  // setselectedcontent(null)
  setselectedcontent({
      ...selectedcontent,
      category: (categories.length ? categories[1] : null),
  });
  setselectedcontent( (contents.filter((content:any) => (content.id==cid)))[0] || {itype:"text"})
  console.log("manging content here ", (contents.filter((content:any) => (content.id==cid))), selectedcontent)
  if (todelete) { setmanagedelete(true) } else { setmanagecontent(true) }
}

const move_content = async (cid:any=null, ocid:any=null, moveup:any=false) => {
  try{
    setshowloader(true);
    const formData = new FormData();
    formData.append('cid', cid);
    formData.append('ocid', ocid);
    formData.append('moveup', moveup);

    const response = await axios.post(`accounts/handlemovecontents`, formData, { withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' } });

    console.log('response____ ', response)
    if (response.status === "DONE") {
        // window.location.reload()
        setshowloader(false);
        fetch_experts();
    }
  } catch (error:any) {
      if (error.response) {
          if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); } 
          else if (error.response.status === 403) {
              setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
              setTimeout(()=>{window.location.href="/logout"}, 2000)
          } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
      } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
      setshowloader(false);
    }  
  
}

document.title = "Domain and Subdomains";
return (
    <React.Fragment>
    <div className="page-content">
        <Container fluid={true}>
        <Breadcrumbs title="Subdomains" breadcrumbItem="Subdomains Content Management" />
        {alertMsgg.open && (
            <Alert
            color={alertMsgg.type === "success" ? "success" : "danger"}
            toggle={handleAlertMsggClose}
            fade={false}
            style={{ fontWeight: "bold" }}
            >
            {alertMsgg.content}
            </Alert>
            )}
            <div className="loaderContainer" hidden={!showloader}>
            <div className="spinner">
              <div></div>  
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
            </div>
          </div>
        <Row>
            <Col md={12}>
            <div className="d-sm-flex justify-content-between align-items-center mb-4">
              <h3 className="mb-sm-0 mb-2 font-size-16">{subpath}</h3>
              <Button color="primary" className="btn btn-primary m-sm-2 " data-toggle="button" aria-pressed="false" onClick={add_edit_content}> <i className="bx bx-plus font-size-16 align-middle me-2"></i>Add New Content</Button>
            </div>

            {/* modal for add/edit domains */}
            <Modal isOpen={managecontent} centered size="lg" toggle={() => { setmanagecontent(!managecontent) }}>
              <ModalHeader className="modal-header" toggle={() => { setmanagecontent(!managecontent) }}> 
                <div className="h5 modal-title" id="addcontentpopup">{selectedcontent?.id ? "Edit" : "Add"} content</div>
              </ModalHeader>
              <div className="modal-body">
                <form>
                  <div className="mb-3">

                    <div className="mb-3 border border-light p-3 rounded-4 ">
                      <label htmlFor="message-text" className="col-form-label">Type of content<span className="text-danger px-1">*</span></label>
                      {/* <textarea  className="form-control"  id="message-text" value={selectedcontent ? selectedcontent.name : ""} required onChange={(e) => { setselectedcontent({ ...selectedcontent, name: e.target.value }) }} /> */}

                      {/* value={managecontent?.cid ? managecontent.cid : ""} */}
                      <select className="form-control"
                      value={selectedcontent?.itype ? selectedcontent.itype : ""}  
                      id="filter_contenttype" name="filter_contenttype"
                      onChange={ (e) => { setselectedcontent({  ...selectedcontent, itype: e.target.value }) }} >
                        {contenttypes.map((ctype:any, index:any)=>(
                            <option key={index} value={ctype}>{ctype}</option>
                        ))}
                      </select>
                      <label htmlFor="message-text" className="col-form-label">HTML Classes (optional):</label>
                      <textarea  className="form-control"  id="contenttext" value={selectedcontent ? selectedcontent.classes : ""} required onChange={(e) => { setselectedcontent({ ...selectedcontent, classes: e.target.value }) }} placeholder="Enter class names here like classname classname ..."/>
                    </div>

                    {/* <div className="mb-3 p-4 border rounded-4 bg-light-blue" hidden={selectedcontent?.itype !== "text"}>
                      <label htmlFor="message-text" className="col-form-label">Text type (optional):</label>
                      <select className="form-control"
                      value={selectedcontent?.ttype ? selectedcontent.ttype : ""}  
                      id="filter_texttype" name="filter_texttype"
                      onChange={ (e) => { setselectedcontent({  ...selectedcontent, ttype: e.target.value }) }} >
                        <option value="">{"None"}</option>
                        {texttypes.map((ttype:any, index:any)=>(
                            <option key={index} value={ttype}>{ttype}</option>
                        ))}
                      </select>
                      <label htmlFor="message-text" className="col-form-label">Enter your text below<span className="text-danger px-1">*</span></label>
                      <textarea  className="form-control"  id="contenttext" value={selectedcontent ? selectedcontent.text : ""} required onChange={(e) => { setselectedcontent({ ...selectedcontent, text: e.target.value }) }} />
                    </div> */}

                    {selectedcontent?.itype === "text" && (<div className="mb-3 border border-light p-3 rounded-4 ">
                      <FormGroup className="mb-4" row>
                        <Label className="col-form-label ">Add you text here</Label>
                        <Col lg={20}>
                          <Editor
                            editorState={editorState}
                            onEditorStateChange={(newState) => {
                              setEditorState(newState);
                              const htmlContent = draftToHtml(convertToRaw(newState.getCurrentContent()));
                              setselectedcontent({ ...selectedcontent, text: htmlContent });
                            }}
                            toolbarClassName="toolbarClassName"
                            wrapperClassName="wrapperClassName"
                            editorClassName="editorClassName"
                            placeholder="Place Your Content Here..."
                          />
                        </Col>
                      </FormGroup>
                    </div>)}
                    
                    <div className="mb-3 p-4 border rounded-4 bg-light-blue" hidden={selectedcontent?.itype !== "image"} >
                      <label htmlFor="message-text" className="col-form-label">Upload your image<span className="text-danger px-1">*</span></label>
                      <div className="mb-3 ddd">
                        <Label className="form-label">Attachment</Label>
                        <Form>
                          <Dropzone
                            onDrop={(acceptedFiles:any) => {
                              handleAcceptedImage(acceptedFiles)
                            }}
                          >
                            {({ getRootProps, getInputProps }:any) => (
                              <div className="dropzone dropZoneSize">
                                <div
                                  className="dz-message needsclick mt-2 p-0"
                                  {...getRootProps()}
                                >
                                  <input {...getInputProps()} />
                                  <div className="mb-2">
                                    <i className="display-5 text-muted bx bxs-cloud-upload" />
                                  </div>
                                  <h4 className="font-size-14">Upload a file.</h4>
                                </div>
                              </div>
                            )}
                          </Dropzone>
                          <div className="dropzone-previews mt-3" id="file-previews">
                            {selectedImage.map((f:any, i:any) => {
                              return (
                                <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-file"}
                                >
                                  <div className="p-2">
                                    <Row className="align-items-center">
                                      <Col className="col-auto">
                                        <img
                                          data-dz-thumbnail=""
                                          height="80"
                                          className="avatar-sm rounded bg-light"
                                          alt={f.name}
                                          src={f.preview}
                                        />
                                      </Col>
                                      <Col>
                                        <Link
                                          to="#"
                                          className="text-muted font-weight-bold"
                                        >
                                          {f.name}
                                        </Link>
                                        <p className="mb-0">
                                          <strong>{f.formattedSize}</strong>
                                        </p>
                                      </Col>
                                    </Row>
                                  </div>
                                </Card>
                              )
                            })}
                          </div>
                        </Form>
                      </div>
                    </div>

                    <div className="mb-3 p-4 border rounded-4 bg-light-blue" hidden={selectedcontent?.itype !== "video"} >
                      <label htmlFor="message-text" className="col-form-label">Upload your video<span className="text-danger px-1">*</span></label>
                      <div className="mb-3">
                        <Label className="form-label">Attachment</Label>
                        <Form>
                          <Dropzone
                            onDrop={(acceptedFiles:any) => {
                              handleAcceptedVideo(acceptedFiles)
                            }}
                          >
                            {({ getRootProps, getInputProps }:any) => (
                              <div className="dropzone dropZoneSize">
                                <div
                                  className="dz-message needsclick mt-2 p-0"
                                  {...getRootProps()}
                                >
                                  <input {...getInputProps()} />
                                  <div className="mb-2">
                                    <i className="display-5 text-muted bx bxs-cloud-upload" />
                                  </div>
                                  <h4 className="font-size-14">Upload a file.</h4>
                                </div>
                              </div>
                            )}
                          </Dropzone>
                          <div className="dropzone-previews mt-3" id="file-previews">
                            {selectedVideo.map((f:any, i:any) => {
                              return (
                                <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-file"}
                                >
                                  <div className="p-2">
                                    <Row className="align-items-center">
                                      <Col className="col-auto">
                                        <img
                                          data-dz-thumbnail=""
                                          height="80"
                                          className="avatar-sm rounded bg-light"
                                          alt={f.name}
                                          src={f.preview}
                                        />
                                      </Col>
                                      <Col>
                                        <Link
                                          to="#"
                                          className="text-muted font-weight-bold"
                                        >
                                          {f.name}
                                        </Link>
                                        <p className="mb-0">
                                          <strong>{f.formattedSize}</strong>
                                        </p>
                                      </Col>
                                    </Row>
                                  </div>
                                </Card>
                              )
                            })}
                          </div>
                        </Form>
                      </div>
                    </div>

                    <div className="mb-3 p-4 border rounded-4 bg-light-blue" hidden={selectedcontent?.itype !== "experts"} >
                      <label htmlFor="message-text" className="col-form-label">Select category for experts<span className="text-danger px-1">*</span></label>
                      <select hidden={selectedcontent?.itype !== "experts"} className="form-control"
                      value={selectedcontent?.category ? selectedcontent.category.id : ""}  
                      id="filter_category" name="filter_category"
                      onChange={ (e) => { setselectedcontent({  ...selectedcontent, category: categories.filter((c:any)=>(e.target.value==c.id))[0]}) }} >
                        <option value="" disabled>Please select category</option>
                        {categories.map((cat:any, index:any)=>(
                            <option key={index} value={cat.id}>{cat.name}</option>
                        ))}
                      </select>
                    </div>

                    


                    <div className="mb-3 p-4 border rounded-4 bg-light-blue" hidden={selectedcontent?.itype !== "rcomponent"} >
                      <label htmlFor="message-text" className="col-form-label">React component placeholder<span className="text-danger px-1">*</span></label>
                      {/* Dropdown for selecting a custom react component */}
                      {selectedcontent?.itype === "rcomponent" && (
                        <select
                          className="form-control mb-2"
                          value={selectedcontent?.rcomponent || ""}
                          onChange={e => setselectedcontent({ ...selectedcontent, rcomponent: e.target.value })}
                        >
                          <option value="" disabled>Select a React Component</option>
                          {CustomReactComponents({component: "", domain: 0, sendKeys: true }).map((component: any) => (
                            <option key={component.key} value={component.key} title={component.description}>
                              {component.title}
                            </option>
                          ))}
                        </select>
                      )}
                      {/* <textarea
                        className="form-control"
                        id="contentrcomponent"
                        value={selectedcontent ? selectedcontent.rcomponent : ""}
                        required
                        onChange={e => setselectedcontent({ ...selectedcontent, rcomponent: e.target.value })}
                      /> */}
                    </div>

                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => { setmanagecontent(!managecontent) }}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={() => add_edit_content(null, true)}>Save</button>
              </div>
            </Modal>

            {/* modal for deleting domain/subdomains */}
            <Modal isOpen={managedelete} centered toggle={() => { setmanagedelete(!managedelete) }}>
              <ModalHeader className="modal-header" toggle={() => { setmanagedelete(!managedelete) }}> 
                <div className="h5 modal-title" id="adddeletepopup">Delete content</div>
              </ModalHeader>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label htmlFor="message-text" className="col-form-label">Are you sure you want to delete this content?"</label>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => { setmanagedelete(!managedelete) }}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={() => add_edit_content(null, true, true)}>Delete</button>
              </div>
            </Modal>

            <Row>
              <Col md={12} className="">

                <Card className="shadow-none rounded-4 bg-light-blue">
                  <CardBody className="">
                    <h5 className="mb-3">Contents:</h5>
                    <div className="p-sm-2">
                        <div>
                          <div>
                            {contents.map((ncontent, ncontentindex) => (
                                <div key={ncontentindex} className="border p-3 rounded-4 mb-4 shadow-sm bg-white">
                                <div>
                                  <div className="d-sm-flex justify-content-between align-items-center border-bottom mb-3 pb-2">
                                    <p className="mb-sm-0 mb-2 font-size-16 fw-medium  text-dark text-capitalize">{ncontent.itype} Component</p>
                                    <div className="d-flex flex-wrap justify-content-sm-end">
                                      <Button color="warning" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => add_edit_content(ncontent.id)}> <i className="bx bxs-pencil font-size-16 align-middle me-2"></i>{" "} Edit</Button>
                                      <Button color="danger" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => add_edit_content(ncontent.id, null, true)}> <i className="bx bxs-trash font-size-16 align-middle me-2"></i>{" "} Delete</Button>
                                      <Button disabled={ncontentindex == 0} color="dark" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => move_content(ncontent.id, (ncontentindex ? contents[ncontentindex-1].id : null), true)}> <i className="bx bx-chevrons-up font-size-16 align-middle me-2"></i>{" "} Move Up</Button>
                                      <Button disabled={ncontentindex == (contents.length-1)} color="dark" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => move_content(ncontent.id, (ncontentindex+1 ? contents[ncontentindex+1].id : null), false)}> <i className="bx bx-chevrons-down font-size-16 align-middle me-2"></i>{" "} Move Down</Button>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  {(() => {
                                  switch (ncontent.itype) {
                                    case 'image':
                                    return (
                                      <div className={`mt-2 ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}>
                                      <img src={ncontent.image} className="w-100 rounded-4 mb-3" alt="Responsive img" />
                                      </div>
                                    );
                                    case 'text':
                                      return (() => {
                                        const contentKey = `${ncontent.id}_${ncontentindex}`;
                                        console.log(`🧠 taskdesc for key ${contentKey}:`, ncontent);
                                        // Use .text when available, otherwise fallback to rendering HTML
                                        // const htmlBlock = (
                                        //   <div
                                        //     className={` ${ncontent.classes}`}
                                        //     key={contentKey}
                                        //     id={`${ncontent.id}`}
                                        //     dangerouslySetInnerHTML={{ __html: ncontent.text }}
                                        //   />
                                        // );
                                        switch (ncontent.ttype) {
                                          // case 'H1': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <h1 className="font-size-18">{ncontent.text} </h1> </div>);

                                          // case 'H2': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <h2 className="font-size-17">{ncontent.text} </h2> </div>);

                                          // case 'H3': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <h3 className="font-size-16">{ncontent.text} </h3> </div>);

                                          // case 'H4': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <h4 className="font-size-15">{ncontent.text} </h4> </div>);

                                          // case 'H5': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <h5 className="font-size-14">{ncontent.text} </h5> </div>);

                                          // case 'H6': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <h6 className="font-size-13">{ncontent.text} </h6> </div>);

                                          // case 'P': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <p> {ncontent.text}</p> </div>);

                                          default:
                                            return (
                                              <div
                                                className={`font-size-15 ${ncontent.classes} my-4`} // margin top & bottom
                                                key={ncontentindex}
                                                id={`${ncontent.id}`}
                                              >
                                                <div className="mt-2" dangerouslySetInnerHTML={{ __html: ncontent.text || '' }} />
                                              </div>
                                            );

                                        }
                                      })();
                                    case 'video':
                                    return (
                                      <div className={ncontent.classes} key={ncontentindex} id={`${ncontent.id}`}>
                                      <div className="embed-responsive embed-responsive-21by9 ratio ratio-21x9 rounded-4 overflow-hidden mb-3">
                                        <iframe className="embed-responsive-item" src={process.env.REACT_APP_BASE_URL + ncontent.video} />
                                      </div>
                                      </div>
                                    );
                                    case 'rcomponent':
                                    return (
                                      <div className={`font-size-16 ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}>
                                      {CustomReactComponents({component: ncontent.rcomponent, domain: 0, sendKeys: true }).filter((c:any) => c.key === ncontent.rcomponent)[0].title}
                                      </div>
                                    );
                                    case 'experts':
                                    return (
                                      <div className={ncontent.classes} key={ncontentindex} id={`${ncontent.id}`}>
                                        <div className="px-2">
                                            <div className="mb-2 text-capitalize text-dark mb-3">experts listings here</div>
                                            {
                                              <Row className="">
                                                <Col lg={4}>
                                                    <Card className="card shadow-none border mb-0 bg-light" aria-hidden="true">
                                                      <CardBody>
                                                        <Row>
                                                          <Col md={3}>
                                                            <img src={ImageHolder} className="card-img-left rounded-2 w-100" height="80" alt="..."/>
                                                          </Col>
                                                          <Col md={9}>
                                                            <div className="d-flex justify-content-between mt-sm-0 mt-2">
                                                              <span className="placeholder col-3 placeholder-sm bg-primary rounded-2"></span>
                                                              <span className="placeholder col-2 placeholder-sm bg-success rounded-2"></span>
                                                            </div>
                                                            <h5 className="card-title pb-3 border-bottom">
                                                                <span className="placeholder col-8"></span>
                                                            </h5>
                                                            <p className="card-text d-flex justify-content-between align-items-start">
                                                                <span className="placeholder col-4 placeholder-sm"></span> 
                                                                <Link to="#" className="btn btn-primary btn-sm disabled placeholder col-3"></Link>
                                                            </p>
                                                          </Col>
                                                        </Row>
                                                      </CardBody>
                                                    </Card>
                                                </Col>
                                                <Col lg={4}>
                                                    <Card className="card shadow-none border mb-0 bg-light" aria-hidden="true">
                                                      <CardBody>
                                                        <Row>
                                                          <Col md={3}>
                                                            <img src={ImageHolder} className="card-img-left rounded-2 w-100" height="80" alt="..."/>
                                                          </Col>
                                                          <Col md={9}>
                                                            <div className="d-flex justify-content-between mt-sm-0 mt-2">
                                                              <span className="placeholder col-3 placeholder-sm bg-primary rounded-2"></span>
                                                              <span className="placeholder col-2 placeholder-sm bg-danger rounded-2"></span>
                                                            </div>
                                                            <h5 className="card-title pb-3 border-bottom">
                                                                <span className="placeholder col-8"></span>
                                                            </h5>
                                                            <p className="card-text d-flex justify-content-between align-items-start">
                                                                <span className="placeholder col-4 placeholder-sm"></span> 
                                                                <Link to="#" className="btn btn-primary btn-sm disabled placeholder col-3"></Link>
                                                            </p>
                                                          </Col>
                                                        </Row>
                                                      </CardBody>
                                                    </Card>
                                                </Col>
                                                <Col lg={4}>
                                                    <Card className="card shadow-none border mb-0 bg-light" aria-hidden="true">
                                                      <CardBody>
                                                        <Row>
                                                          <Col md={3}>
                                                            <img src={ImageHolder} className="card-img-left rounded-2 w-100" height="80" alt="..."/>
                                                          </Col>
                                                          <Col md={9}>
                                                            <div className="d-flex justify-content-between mt-sm-0 mt-2">
                                                              <span className="placeholder col-3 placeholder-sm bg-primary rounded-2"></span>
                                                              <span className="placeholder col-2 placeholder-sm bg-success rounded-2"></span>
                                                            </div>
                                                            <h5 className="card-title pb-3 border-bottom">
                                                                <span className="placeholder col-8"></span>
                                                            </h5>
                                                            <p className="card-text d-flex justify-content-between align-items-start">
                                                                <span className="placeholder col-4 placeholder-sm"></span> 
                                                                <Link to="#" className="btn btn-primary btn-sm disabled placeholder col-3"></Link>
                                                            </p>
                                                          </Col>
                                                        </Row>
                                                      </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            }
                                        </div>
                                      </div>
                                    );
                                    default:
                                  }})()}
                                </div>
                                  {(ncontent.classes ? <div className="text-mute border-top mt-3 pt-2"><span className="fw-medium">Classes:</span> {ncontent.classes}</div> : null)}
                              </div>
                            ))}
                          </div>
                        </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            </Col>
        </Row>
        </Container>
    </div>
    </React.Fragment>
);

};
export default NavContentManagement;
